export default "__VITE_ASSET__B7sIUU$7__"